<template>
	<div class="main loginMain">
		<div class="main"></div>
		<div class="header">
			<div class="header-center fl">
				<div class="header-title">{{ webtitle }}</div>
				<div class="header-img"></div>
			</div>
			<div class="header-bottom fl"></div>
		</div>

		<div class="content">
			<div class="content-left"></div>
			<div class="content-right">
				<!-- 登陆组件 -->
				<login :form="form" @handle="handle" ref="login" :isLogin="loginOrRegister" v-show="loginOrRegister" @register="loginOrRegisterHandle(false)" />
				<!-- 注册组件 -->
				<register
					:shoplist="shoplist"
					:form="form"
					@handle="handle"
					ref="register"
					:isRegister="!loginOrRegister"
					v-show="!loginOrRegister"
					@login="loginOrRegisterHandle(true)"
				/>
			</div>
		</div>
		<el-dialog :visible.sync="showscanewm" title="扫码验证" width="500px" :close-on-click-modal="false" lock-scroll :show-close="false" :append-to-body="true">
			<div class="verifyewm">
				<el-row>
					<el-col :span="2"><span style="color:transparent">1</span></el-col>
					<el-col :span="22">
						<span>扫描微信二维码验证，若未关注此公众号，请关注后再扫描</span>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6"><span style="color:transparent">1</span></el-col><el-col :span="12">
					<img style="width:200px" :src="verifyewm"></el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-row>
					<el-col :span="18">
						<span style="color:transparent">1</span>
					</el-col>
					<el-col :span="4" style="text-align:right;"><el-button @click="Register(2)" size="medium" type="primary">我已扫码验证</el-button></el-col>
				</el-row>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import login from '@/components/login/login.vue';
import register from '@/components/register/register.vue';
export default {
	components: {
		login,
		register
	},
	data() {
		return {
			webtitle: '',
			shoplist: [],
			form: {
				account: '',
				password: '',
				shop: ''
			},
			loginOrRegister: true,
			showscanewm:false,
			verifyewm:'',
			ewmid:''
		};
	},
	mounted() {
		var that = this;
		import('../../static/' + this.$theme + '/style/login.scss');
		this.webtitle =localStorage.getItem('webtitle');
	},
	methods: {
		init(){
			if (this.loginOrRegister) {
				this.$refs.login.$refs.account.focus();
			} else {
				this.$refs.register.$refs.reaccount.focus();
			}
		},
		loginOrRegisterHandle(e) {
			var that = this;
			this.loginOrRegister = e;
			if (this.loginOrRegister) {
				this.$refs.login.updateIsLogin(this.loginOrRegister);
			} else {
				this.$apipost.get.GetGroup({ search: '', isshop: true, userid: '' }).then(res => {
					//console.log('注册门店',res);
					if (res.list != '') {
						that.shoplist = res.list;
						that.form.shop = that.shoplist[0].s_name;
					}
				});
				this.$refs.register.updateIsRegister(this.loginOrRegister);
			}
		},
		handle(e) {
			this.form = e;
			if (this.loginOrRegister) {
				this.Login();
			} else {
				this.Register();
			}
		},
		Login() {
			var that=this;
			//验证登录
			if (this.form.account == '') {
				this.$tool.message('请输入登录账号', 0);
				return false;
			}
			if (this.form.password == '') {
				this.$tool.message('请输入登录密码', 0);
				return false;
			}
			this.$tool.loading('正在登录', 'loginMain');
			this.$apipost.post.login({ account: this.form.account, password:this.$tool.setPwd(this.form.password) }).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if (res.state == '1') {
						if (res.token != '' && res.token != undefined) {
							localStorage.setItem('token', res.token);
							//that.sysinfo();
							this.$router.push('/');
						}
					} else {
						this.$tool.message(res.message, 0);
					}
				}
			}).catch(e=>{
				this.$tool.loadingclose();
				this.$tool.message('网络异常，请重试', 0);
			});
		},
		Register(handletype) {
			var that=this;
			//验证登录
			if(handletype==undefined)
				handletype=1;
			if (this.form.account == '') {
				this.$tool.message('请输入注册账号', 0);
				return false;
			}
			if (this.form.password == '') {
				this.$tool.message('请输入密码', 0);
				return false;
			}
			if (this.form.shop == '') {
				this.$tool.message('请选择门店', 0);
				return false;
			}
			this.$tool.loading('正在注册', 'loginMain');
			var paraminfo={
				account: this.form.account,
				password: this.$tool.setPwd(this.form.password), 
				shopname: this.form.shop,
				handletype:handletype,
				ewmid:this.ewmid
			}
			this.$apipost.post.registerAccount({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res != '') {
					if (res.state == '1') {
						that.showscanewm=false;
						if (res.token != '' && res.token != undefined) {
							localStorage.setItem('token', res.token);
							//that.sysinfo();
							this.$router.push('/');
						}
					} else {
						if(res.state=='2'){
							that.showscanewm=true;
							that.verifyewm=res.ewm;
							that.ewmid=res.ewmid;
						}
						else this.$tool.message(res.message, 0);
					}
				}
			}).catch(e=>{
				this.$tool.loadingclose();
				this.$tool.message('网络异常，请重试', 0);
			});
		},
		goLogin() {
			this.$emit('login');
		}
	}
};
</script>
